export default __webpack_public_path__ + "static/media/LAS0880.34I-39648_-23539_0.e29541fb.jpg";